import { ReactElement } from 'react';
import Table from '@/common/Table';

export type TrainerItem = {
  category: string;
  evaluator: string;
  roles: string[];
};

export type TrainingReportPdfEvaluatorsRowProps = {
  items: TrainerItem[];
  colSpan: number;
};

const TrainingReportPdfEvaluatorsRow = ({ items, colSpan }: TrainingReportPdfEvaluatorsRowProps): ReactElement => (
  <Table.Row className="TrainingReportPdf-EvaluatorsRow" virtualize={false}>
    <Table.Cell className="EVALUATORS" colSpan={colSpan}>
      <div className="TrainingReportPdf-Evaluators">
        {items.map(({ category, evaluator, roles }, i) => [
          <span key={`${i}-category`}>{category}</span>,
          <span key={`${i}-evaluator`}>{evaluator}</span>,
          <span key={`${i}-roles`}>{roles.length ? roles.join(', ') : '--'}</span>,
        ])}
      </div>
    </Table.Cell>
  </Table.Row>
);

export default TrainingReportPdfEvaluatorsRow;
